import { fetchApiData } from '../FetchISR'

export const fetchPropertyListing = async ({ query }) => {
  return fetchApiData(
    'propertyListing',
    `${process.env.NEXT_PUBLIC_API_BASE_URL}/v2/vacation-rental/search/?${new URLSearchParams(query).toString()}`
  )
}
